/* =========================================================
   QUICK BUY MODAL – FULL SCRIPT
   (mantém tudo igual, só faz reload após adicionar ao carrinho)
   ========================================================= */
(function () {
  const QB_SHOULD_OPEN_CART_AFTER_RELOAD = 'qb_open_cart_after_reload';

  // ✅ If we reloaded after add-to-cart, open drawer now
  try {
    if (sessionStorage.getItem(QB_SHOULD_OPEN_CART_AFTER_RELOAD) === '1') {
      sessionStorage.removeItem(QB_SHOULD_OPEN_CART_AFTER_RELOAD);
      // open drawer best-effort
      setTimeout(() => {
        openCartDrawerBestEffort();
      }, 50);
    }
  } catch (e) {}

  const modal = document.getElementById('QuickBuyModal');
  const modalContent = document.getElementById('QuickBuyModalContent');
  if (!modal || !modalContent) return;

  function qs(sel, ctx = document) {
    return ctx.querySelector(sel);
  }
  function qsa(sel, ctx = document) {
    return Array.from(ctx.querySelectorAll(sel));
  }

  function openModal() {
    modal.hidden = false;
    document.documentElement.classList.add('qb-no-scroll');
  }

  function closeModal() {
    modal.hidden = true;
    modalContent.innerHTML = '';
    document.documentElement.classList.remove('qb-no-scroll');
  }

  async function addToCartAjax(form) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  // Open cart drawer best-effort (no redirect)
  function openCartDrawerBestEffort() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent('drawer:open', { bubbles: true, detail: { drawer: 'cart' } })
      );
    } catch (e) {}

    try {
      if (window.theme?.Cart?.open) {
        window.theme.Cart.open();
        return true;
      }
      if (window.theme?.cartDrawer?.open) {
        window.theme.cartDrawer.open();
        return true;
      }
    } catch (e) {}

    try {
      const drawerEl =
        document.querySelector('cart-drawer') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('[id*="CartDrawer"]') ||
        document.querySelector('[data-drawer-id*="cart"]');

      if (drawerEl && typeof drawerEl.open === 'function') {
        drawerEl.open();
        return true;
      }
      if (drawerEl?.setAttribute && !drawerEl.hasAttribute('open')) {
        drawerEl.setAttribute('open', '');
        return true;
      }
    } catch (e) {}

    const toggles = [
      '[data-action="open-drawer"][data-drawer-id*="cart"]',
      '[aria-controls="CartDrawer"]',
      '[aria-controls*="cart"]',
      '.Header__CartToggle',
      '.Header__CartIcon',
      '.js-drawer-open-cart',
      '.cart-drawer-button',
      'button[name="open-cart"]'
    ];

    for (const sel of toggles) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        return true;
      }
    }

    return false;
  }

  // Prevent navigation only if "+" is inside a link
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.ProductItem__QuickAddButton');
      if (!btn) return;

      if (btn.closest('a')) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Open modal on multi-variant
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-open-quickbuy');
    if (!btn) return;

    e.preventDefault();

    const url = btn.getAttribute('data-product-url');
    if (!url) return;

    openModal();
    modalContent.innerHTML = '<div style="padding:16px;">A carregar…</div>';

    fetch(url + (url.includes('?') ? '&' : '?') + 'view=quick-buy', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((r) => r.text())
      .then((html) => {
        modalContent.innerHTML = html;
        initQuickBuy(modalContent);
      })
      .catch((err) => {
        console.error(err);
        modalContent.innerHTML = '<div style="padding:16px;">Erro ao carregar.</div>';
      });
  });

  // Close modal
  modal.addEventListener('click', (e) => {
    if (e.target.matches('[data-qb-close]')) closeModal();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  function initQuickBuy(root) {
    const mainImage = qs('#QBMainImage', root);
    const variantInput = qs('[data-qb-variant-id]', root);

    // Update "selected value" labels (right side)
    function updateSelectedLabels() {
      qsa('[data-qb-option-group]', root).forEach((group) => {
        const pos = group.getAttribute('data-qb-position');
        const checked = qs(`input[data-qb-option-position="${pos}"]:checked`, group);
        const label = qs(`[data-qb-selected-label="${pos}"]`, group);
        if (checked && label) label.textContent = checked.value;
      });
    }

    // Parse variants json
    let variants = [];
    try {
      const script = qs('script[data-qb-variants]', root);
      variants = script ? JSON.parse(script.textContent) : [];
    } catch (e) {
      variants = [];
    }

    function normalizeSrc(src) {
      if (!src) return '';
      return src.startsWith('//') ? 'https:' + src : src;
    }

    function setMainImage(src) {
      if (!mainImage || !src) return;
      mainImage.src = normalizeSrc(src);
    }

    function getSelectedOptions() {
      const o1 = qs('input[data-qb-option-position="1"]:checked', root)?.value || null;
      const o2 = qs('input[data-qb-option-position="2"]:checked', root)?.value || null;
      const o3 = qs('input[data-qb-option-position="3"]:checked', root)?.value || null;
      return [o1, o2, o3];
    }

    function findVariantByOptions([o1, o2, o3]) {
      return variants.find((v) => {
        return v.option1 === o1 && (!o2 || v.option2 === o2) && (!o3 || v.option3 === o3);
      });
    }

    function syncVariantAndImage() {
      updateSelectedLabels();

      const selected = getSelectedOptions();
      const variant = findVariantByOptions(selected);

      if (variant && variantInput) {
        variantInput.value = variant.id;
      }

      const checkedWithImage = qs('input[data-qb-variant-image]:checked', root);
      const dataImg = checkedWithImage ? checkedWithImage.getAttribute('data-qb-variant-image') : '';

      if (dataImg) {
        setMainImage(dataImg);
        return;
      }

      const vImg = variant?.featured_image?.src || variant?.featured_image?.url || '';
      if (vImg) setMainImage(vImg);
    }

    qsa('input[data-qb-option]', root).forEach((input) => {
      input.addEventListener('change', syncVariantAndImage);
    });

    qsa('[data-qb-qty]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.getAttribute('data-qb-qty'), 10);
        const input = qs('.qb__qty-input', root);
        if (!input) return;

        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    syncVariantAndImage();

    // Add to cart inside modal
    const form = qs('form[action="/cart/add"]', root);
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        try {
          await addToCartAjax(form);

          // ✅ NEW: reload page after add (and open cart drawer after reload)
          try {
            sessionStorage.setItem(QB_SHOULD_OPEN_CART_AFTER_RELOAD, '1');
          } catch (e) {}

          closeModal();
          window.location.reload();
        } catch (err) {
          console.error(err);
          form.submit();
        }
      });
    }
  }

  // Quick add (1-variant products) from grid
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-quick-add-form');
    if (!form) return;

    e.preventDefault();

    try {
      await addToCartAjax(form);

      // ✅ NEW: reload page after add (and open cart drawer after reload)
      try {
        sessionStorage.setItem(QB_SHOULD_OPEN_CART_AFTER_RELOAD, '1');
      } catch (e) {}

      window.location.reload();
    } catch (err) {
      console.error(err);
      form.submit();
    }
  });
})();
